export default function Hero() {
  return (
    <section id="hero" className="relative min-h-screen flex items-center pt-[72px] overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-primary-50/30"></div>

      <div className="relative w-full px-4 md:px-6 py-12 md:py-20">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-sm font-bold mb-6">
              <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse-dot"></span>
              实时更新 · 7×24小时不间断
            </div>

            <h1 className="font-heading font-black text-3xl sm:text-4xl md:text-5xl lg:text-5xl xl:text-6xl text-foreground-950 leading-tight mb-4">
              五一黑料网
              <br />
              <span className="text-primary-600">深度瓜田爆料与黑料内幕平台</span>
            </h1>

            <p className="text-foreground-600 text-base md:text-lg leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6">
              五一黑料网深度挖掘瓜田爆料、黑料内幕及吃瓜事件，实时追踪全网热点瓜与今日黑料最新动态。
              从顶流塌房到选秀内幕，从恋情曝光到税务风波，我们不做搬运工，只挖真内幕。
              每日更新吃瓜合集与最新黑料视频，让你第一时间掌握娱乐圈风吹草动。
              当前热门：顶流税务风波持续发酵，选秀内幕深度调查进行中。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-black text-primary-600">280万+</div>
                <div className="text-xs text-foreground-500 mt-1">日活吃瓜用户</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-black text-primary-600">500+</div>
                <div className="text-xs text-foreground-500 mt-1">日均爆料条数</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-black text-primary-600">15分钟</div>
                <div className="text-xs text-foreground-500 mt-1">重大事件响应</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#topics"
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 font-bold text-sm rounded-lg hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap text-center"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#topics')?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                立即吃瓜 <i className="ri-arrow-right-line ml-1"></i>
              </a>
              <a
                href="#ranking"
                className="w-full sm:w-auto px-8 py-3.5 bg-background-100 text-foreground-800 font-medium text-sm rounded-lg hover:bg-background-200 transition-colors cursor-pointer whitespace-nowrap text-center border border-background-300"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                查看热度榜单 <i className="ri-fire-line ml-1"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-br from-primary-400/20 via-accent-400/15 to-primary-300/10 rounded-3xl blur-2xl"></div>
              <div className="relative grid grid-cols-2 gap-3">
                <div className="col-span-2">
                  <img
                    src="https://readdy.ai/api/search-image?query=Breaking%20entertainment%20news%20concept%2C%20dramatic%20red%20and%20dark%20atmosphere%2C%20headline%20news%20collage%2C%20celebrity%20scandal%20vibe%2C%20investigative%20journalism%20mood%2C%20warm%20dramatic%20lighting%20on%20dark%20background&width=800&height=450&seq=hero-main&orientation=landscape"
                    alt="五一黑料网娱乐八卦头版焦点"
                    className="w-full rounded-xl object-cover aspect-[16/9] object-top"
                  />
                </div>
                <img
                  src="https://readdy.ai/api/search-image?query=TV%20studio%20behind%20scenes%20drama%2C%20spotlight%20on%20empty%20stage%2C%20entertainment%20industry%20photography%2C%20warm%20amber%20lighting&width=400&height=280&seq=hero-sub-01&orientation=landscape"
                  alt="综艺录制现场内幕爆料"
                  className="w-full rounded-xl object-cover aspect-[4/3] object-top"
                />
                <img
                  src="https://readdy.ai/api/search-image?query=Paparazzi%20camera%20and%20newspaper%20concept%2C%20investigative%20mood%2C%20dramatic%20shadows%2C%20celebrity%20news%20atmosphere&width=400&height=280&seq=hero-sub-02&orientation=landscape"
                  alt="狗仔追踪娱乐圈最新黑料"
                  className="w-full rounded-xl object-cover aspect-[4/3] object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}